import { useRouter } from 'next/router';

import { useSelector } from 'react-redux';
import style from '../index.module.scss';
import { useI18n } from '@lib/i18n';

export default function SaveAndShare({ toggleMenuState = false, isAdvisorView = false }) {
	const router = useRouter();
	const { t } = useI18n();

	const { authenticated, isOnline } = useSelector((state) => state.user);

	const hideHeaderButtonsForViews = [
		'/auth/login',
		'/auth/register',
		'/auth/personalise',
		'/advisor',
		'/personalise',
		'/everything',
		'/share',
		'/configure',
	];

	if (isAdvisorView) {
		return;
	}

	if (hideHeaderButtonsForViews.includes(router.pathname)) {
		return;
	}

	if (!isOnline) {
		return;
	}

	const shareProspectus = () => {
		if (toggleMenuState) {
			toggleMenuState(false);
		}

		let route = '/share';

		if ('/prospectus/[slug]' === router.pathname) {
			route = route + '?saveOff=true';
		}

		router.push(route);
	};

	return (
		<ul id="save_or_share">
			{authenticated && (
				<li>
					<button
						disabled={!authenticated}
						onClick={() => shareProspectus()}
						className={`saveShareBtn btnComponent`}
					>
						<span className={style.text}>{t('header.share', 'Share')}</span>
					</button>
				</li>
			)}
		</ul>
	);
}
